import { Button, ButtonProps } from "@mui/material";
import React from "react";
import { ModalContext } from "..";
import ModalOrderFileFixingAction, { ModalOrderFileFixingActionElementProps } from "./modal-order-file-fixing-action";
import ConstructionIcon from "@mui/icons-material/Construction";
import { AclMatch, UserHasAcls, UserHasLicence } from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { Licences } from "../../../Core/Api/Types/licences";
import { useTranslation } from "react-i18next";

export interface ModalConfirmActionOpenButtonProps extends ButtonProps {
  modalTitle?: string;
  objectId: number;
  onConfirm?: (comment?: string) => void;
}

const ModalOrderFileFixingOpenButton: React.FC<ModalConfirmActionOpenButtonProps> = (props) => {
  const { t } = useTranslation();
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const { modalTitle, onConfirm, objectId, ...otherProps } = props;

  const handleButtonClick: React.MouseEventHandler = () => {
    if (!openModal) {
      return;
    }

    openModal<ModalOrderFileFixingActionElementProps>(ModalOrderFileFixingAction, {
      title: modalTitle,
      objectId: objectId,
      onConfirm,
    });
  };

  return (
    <>
      {UserHasAcls([AclTypes.aclOrderQuoteRequest, AclTypes.aclAdmin, AclTypes.aclSuperUser], AclMatch.OneAtLeast) &&
        UserHasLicence(Licences.QuoteManagement) && (
          <Button
            {...otherProps}
            onClick={handleButtonClick}
            color="primary"
            variant="outlined"
            startIcon={<ConstructionIcon />}
          >
            {t("button:requestFileFixing")}
          </Button>
        )}
    </>
  );
};

export default ModalOrderFileFixingOpenButton;
